// Mock data for Design Plus printing website
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_c8f3e194-f21b-49ad-aa9b-276cc48e0e2d/artifacts/5cr1yjo9_web-Logo.png";
export const LP_LOGO_URL = "https://customer-assets.emergentagent.com/job_design-plus-print/artifacts/ufnephhm_LP%20FINAL%20LOGO%20WEBSITE.png";

export const COMPANY = {
  name: "Design Plus",
  phone: "754-755-1819",
  phoneRaw: "+17547551819",
  address: "3291 W Sunrise Blvd, Fort Lauderdale, FL 33311",
  email: "orders@dplus.ai",
  hours: "Mon–Sat 9:30am–5:00pm",
};

export const CATEGORIES = [
  { slug: "business-cards", name: "Business Cards", icon: "CreditCard", image: "https://images.unsplash.com/photo-1628891439478-c613e85af7d6?w=600" },
  { slug: "marketing-material", name: "Marketing Material", icon: "Megaphone", image: "https://images.unsplash.com/photo-1591351659190-6258bbec984d?w=600" },
  { slug: "signs-banners", name: "Signs & Banners", icon: "Flag", image: "https://images.unsplash.com/photo-1523800378286-dae1f0dae656?w=600" },
  { slug: "labels-stickers", name: "Labels & Stickers", icon: "Sticker", image: "https://images.unsplash.com/photo-1633533452206-8ab246b00e30?w=600" },
  { slug: "print-stationery", name: "Print Stationery", icon: "FileText", image: "https://images.unsplash.com/photo-1656379817721-774050a70dd0?w=600" },
  { slug: "gang-sheet-printing", name: "Gang Sheet Printing", icon: "Layers", image: "https://images.unsplash.com/photo-1580566176138-daa588058b59?w=600" },
];

// All products with full configuration data
export const PRODUCTS = [
  // BUSINESS CARDS
  {
    slug: "regular-business-card",
    name: "Regular Business Cards",
    category: "business-cards",
    tagline: "The everyday card. Quietly impressive.",
    description: "Hand someone a card that feels as serious as you are. Printed on a substantial 16pt premium coated stock with optional gloss finish — your contact details earn their place in someone's wallet, not their trash bin. Pick standard or square, matte or gloss, square or rounded corners.",
    fromPrice: 34.99,
    image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/pht4g21z_DPLUS%20REGULAR%204.PNG",
    gallery: [
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/pht4g21z_DPLUS%20REGULAR%204.PNG",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/h3fabqsn_DPLUS%20REGULAR%201.PNG",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/wxednfcd_DPLUS%20REGULAR%202.PNG",
    ],
    rating: 4.8,
    reviews: 312,
    features: ["16pt premium coated stock", "Full color double-sided print", "Standard or square shape", "Matte or gloss finish"],
    sizes: ["Standard 2.0\" × 3.5\"", "Square 2.56\" × 2.56\""],
    finishes: ["Matte", "Gloss"],
    corners: ["Square", "Rounded"],
    pricing: [
      { qty: 100, perUnit: 0.35, price: 34.99 },
      { qty: 250, perUnit: 0.18, price: 44.99 },
      { qty: 500, perUnit: 0.12, price: 59.99 },
      { qty: 1000, perUnit: 0.06, price: 64.99 },
      { qty: 2500, perUnit: 0.04, price: 99.99 },
      { qty: 5000, perUnit: 0.03, price: 149.99 },
      { qty: 10000, perUnit: 0.02, price: 249.99 },
    ],
    designFee: 35,
    productionDays: "5–6",
  },
  {
    slug: "spot-uv-business-cards",
    name: "Spot UV Business Cards",
    category: "business-cards",
    tagline: "A subtle shine where it counts.",
    description: "Built on 16pt soft-touch matte stock with a thick raised varnish on the parts you want to pop. Logos, taglines, monograms — anything you spotlight becomes both visible and tactile. Hand it out once and your client's thumb will run across it three times.",
    fromPrice: 199.99,
    image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/myjtrcay_SPOT%20UV%202.PNG",
    gallery: [
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/myjtrcay_SPOT%20UV%202.PNG",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/4esylhak_SPOT%20UV%201.PNG",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/bf36y4de_SPOT%20UV%203.PNG",
    ],
    rating: 4.9,
    reviews: 187,
    features: ["Raised glossy Spot UV accents", "16pt soft-touch card stock", "3.5\" × 2\" standard size", "Front-only or both sides"],
    sides: ["Front Only", "Front and Back"],
    pricing: [
      { qty: 100, perUnit: 2.0, price: 199.99 },
      { qty: 250, perUnit: 1.0, price: 249.99 },
      { qty: 500, perUnit: 0.6, price: 299.99 },
      { qty: 1000, perUnit: 0.35, price: 349.99 },
    ],
    designFee: 55,
    productionDays: "10–12",
  },
  {
    slug: "extra-thick-business-cards",
    name: "Extra Thick Business Cards",
    category: "business-cards",
    tagline: "Cards heavy enough to leave a mark.",
    description: "Printed on a 32pt double-thick premium card stock, these cards are nearly twice the weight of standard cards. The colored edge between the two layers (your choice of red, black, navy or white) becomes a tiny brand moment all on its own.",
    fromPrice: 149.99,
    image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/f6ho3iy4_Extra%20Thick%20Cards%20DPLUS%202.png",
    gallery: ["https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/f6ho3iy4_Extra%20Thick%20Cards%20DPLUS%202.png"],
    rating: 4.9,
    reviews: 142,
    features: ["32pt double-thick card stock", "Painted color edges available", "Soft-touch matte coating", "Made in the USA"],
    sizes: ["Standard 2.0\" × 3.5\""],
    edgeColors: ["Black", "Red", "Navy", "White"],
    pricing: [
      { qty: 100, perUnit: 1.50, price: 149.99 },
      { qty: 250, perUnit: 0.80, price: 199.99 },
      { qty: 500, perUnit: 0.50, price: 249.99 },
      { qty: 1000, perUnit: 0.30, price: 299.99 },
    ],
    designFee: 45,
    productionDays: "7–9",
  },
  {
    slug: "plastic-business-cards",
    name: "Plastic Business Cards",
    category: "business-cards",
    tagline: "Waterproof, tear-proof, unforgettable.",
    description: "Printed on a 20mil flexible plastic stock that bends but never breaks. Available in clear frosted, opaque white or fully transparent — perfect for gym memberships, VIP cards, salons and brands that want to be remembered for a decade.",
    fromPrice: 169.99,
    image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/ak3zicpe_Plastic%20BC%201.PNG",
    gallery: ["https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/ak3zicpe_Plastic%20BC%201.PNG"],
    rating: 4.8,
    reviews: 96,
    features: ["20mil flexible plastic", "Waterproof and tear-proof", "Frosted, opaque or clear", "Rounded corners standard"],
    sizes: ["Standard 2.0\" × 3.5\""],
    finishes: ["Frosted", "Opaque White", "Clear Transparent"],
    pricing: [
      { qty: 100, perUnit: 1.70, price: 169.99 },
      { qty: 250, perUnit: 0.90, price: 224.99 },
      { qty: 500, perUnit: 0.60, price: 299.99 },
      { qty: 1000, perUnit: 0.40, price: 399.99 },
    ],
    designFee: 50,
    productionDays: "10–12",
  },
  {
    slug: "raised-foil-business-cards",
    name: "Raised Foil Business Cards",
    category: "business-cards",
    tagline: "Metallic accents that catch every light.",
    description: "Premium 16pt soft-touch cards finished with raised metallic foil — gold, silver, rose or copper. The foil sits proud of the surface so it both sparkles and gives a satisfying tactile lift. Reserved for brands that mean business.",
    fromPrice: 189.99,
    image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/d23krsc4_Raised%20Foil%201.PNG",
    gallery: ["https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/d23krsc4_Raised%20Foil%201.PNG"],
    rating: 5.0,
    reviews: 78,
    features: ["Raised metallic foil", "16pt soft-touch base", "Gold, silver, rose or copper", "Front or both sides"],
    foilColors: ["Gold", "Silver", "Rose Gold", "Copper"],
    sides: ["Front Only", "Front and Back"],
    pricing: [
      { qty: 100, perUnit: 1.90, price: 189.99 },
      { qty: 250, perUnit: 1.00, price: 249.99 },
      { qty: 500, perUnit: 0.65, price: 324.99 },
      { qty: 1000, perUnit: 0.40, price: 399.99 },
    ],
    designFee: 65,
    productionDays: "12–14",
  },

  // MARKETING MATERIAL
  {
    slug: "flyers",
    name: "Flyers",
    category: "marketing-material",
    tagline: "Hand-them-out marketing that gets noticed.",
    description: "Heavy 16pt card stock flyers that don't feel like the cheap stuff. Five popular sizes from pocket-friendly 4×6 to full-page 8.5×11. Matte or glossy finish. Print one side or both for the same price — really.",
    fromPrice: 79.99,
    image: "https://images.unsplash.com/photo-1591351659190-6258bbec984d?w=900",
    gallery: ["https://images.unsplash.com/photo-1591351659190-6258bbec984d?w=900", "https://images.unsplash.com/photo-1658863025658-4a259cc68fc9?w=900"],
    rating: 4.7,
    reviews: 264,
    features: ["16pt card stock", "Matte or glossy finish", "Front + back same price", "5 popular sizes"],
    sizes: ["4\" × 6\"", "5\" × 7\"", "4\" × 9\"", "6.25\" × 9\"", "8.5\" × 11\""],
    finishes: ["Matte", "Glossy"],
    sides: ["Front Only", "Front and Back"],
    pricing: [
      { qty: 100, perUnit: 0.80, price: 79.99 },
      { qty: 250, perUnit: 0.40, price: 99.99 },
      { qty: 500, perUnit: 0.24, price: 119.99 },
      { qty: 1000, perUnit: 0.13, price: 129.99 },
      { qty: 2500, perUnit: 0.08, price: 199.99 },
      { qty: 5000, perUnit: 0.05, price: 249.99 },
      { qty: 10000, perUnit: 0.05, price: 499.99 },
    ],
    designFee: 55,
    productionDays: "5–6",
  },
  {
    slug: "eddm-postcards",
    name: "EDDM Postcards",
    category: "marketing-material",
    tagline: "Every door direct — every neighbor reached.",
    description: "Every Door Direct Mail postcards print at USPS-approved sizes and ship preflighted with carrier-route tools so you can target by ZIP. Heavy 14pt gloss stock keeps the print crisp from press to mailbox.",
    fromPrice: 109.99,
    image: "https://images.unsplash.com/photo-1656379817721-774050a70dd0?w=900",
    gallery: ["https://images.unsplash.com/photo-1656379817721-774050a70dd0?w=900"],
    rating: 4.6,
    reviews: 138,
    features: ["USPS EDDM-approved sizes", "14pt gloss stock", "Carrier route prep", "Full color both sides"],
    sizes: ["6.5\" × 9\"", "6.25\" × 11\"", "8.5\" × 11\""],
    pricing: [
      { qty: 250, perUnit: 0.44, price: 109.99 },
      { qty: 500, perUnit: 0.30, price: 149.99 },
      { qty: 1000, perUnit: 0.20, price: 199.99 },
      { qty: 2500, perUnit: 0.12, price: 299.99 },
      { qty: 5000, perUnit: 0.10, price: 499.99 },
    ],
    designFee: 65,
    productionDays: "6–8",
  },
  {
    slug: "car-magnets",
    name: "Car Magnets",
    category: "marketing-material",
    tagline: "Turn your car into a billboard.",
    description: "Printed on 30 mil premium magnet stock with a UV-protected gloss top. Removable, non-damaging and weather-resistant for years of mobile advertising. Three popular sizes plus fully custom dimensions.",
    fromPrice: 70,
    image: "https://images.unsplash.com/photo-1593238404535-cda7ae2fe50b?w=900",
    gallery: ["https://images.unsplash.com/photo-1593238404535-cda7ae2fe50b?w=900"],
    rating: 4.8,
    reviews: 211,
    features: ["30 mil magnet stock", "UV-protected coating", "Removable and non-damaging", "Weather-resistant"],
    sizes: ["12\" × 18\" — $33.66/ea", "14\" × 24\" — $52.36/ea", "18\" × 24\" — $67.32/ea", "Custom size"],
    pricing: [
      { qty: 1, perUnit: 70, price: 70 },
      { qty: 2, perUnit: 67.32, price: 134.64 },
      { qty: 4, perUnit: 64, price: 256 },
    ],
    designFee: 35,
    productionDays: "5–6",
  },
  {
    slug: "brochures",
    name: "Brochures",
    category: "marketing-material",
    tagline: "Fold-and-go storytelling for your brand.",
    description: "Bi-fold or tri-fold brochures printed on 100lb gloss text stock. Crisp creases, vibrant color, and full-bleed designs that unfold like a story. Perfect for menus, programs and service overviews.",
    fromPrice: 119.99,
    image: "https://images.unsplash.com/photo-1658863025658-4a259cc68fc9?w=900",
    gallery: ["https://images.unsplash.com/photo-1658863025658-4a259cc68fc9?w=900"],
    rating: 4.7,
    reviews: 152,
    features: ["100lb gloss text stock", "Bi-fold or tri-fold", "Full color both sides", "Score and fold included"],
    sizes: ["8.5\" × 11\" Tri-fold", "8.5\" × 11\" Bi-fold", "8.5\" × 14\" Tri-fold", "11\" × 17\" Bi-fold"],
    folds: ["Bi-fold", "Tri-fold", "Z-fold"],
    pricing: [
      { qty: 100, perUnit: 1.20, price: 119.99 },
      { qty: 250, perUnit: 0.72, price: 179.99 },
      { qty: 500, perUnit: 0.50, price: 249.99 },
      { qty: 1000, perUnit: 0.34, price: 339.99 },
      { qty: 2500, perUnit: 0.22, price: 549.99 },
    ],
    designFee: 75,
    productionDays: "6–8",
  },
  {
    slug: "retractable-banner",
    name: "Retractable Banner",
    category: "marketing-material",
    tagline: "Command the room at your next event.",
    description: "Premium 33\" × 80\" retractable banners on 10 mil scuff-resistant indoor vinyl. Zero-tool 30-second setup, carrying case included. Pick a silver, black or chrome deluxe base — or add NFC for tap-to-launch interactions.",
    fromPrice: 160,
    image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/30wrpnn7_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/30wrpnn7_image.png",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/yxzboa85_image.png",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/n7lan0vo_image.png",
    ],
    rating: 4.9,
    reviews: 173,
    features: ["33\" × 80\" banner", "10 mil indoor vinyl", "Zero-tool 30-sec setup", "Carrying case included"],
    stands: [
      { name: "Regular", price: 160, desc: "Silver aluminum base — classic event look." },
      { name: "Regular Black", price: 185, desc: "Matte-black base for darker venues." },
      { name: "Deluxe", price: 250, desc: "Premium chrome base, smoother retraction." },
      { name: "Black + NFC", price: 250, desc: "Matte-black with built-in NFC tap chip." },
    ],
    pricing: [{ qty: 1, perUnit: 160, price: 160 }],
    designFee: 55,
    productionDays: "5–6",
  },

  // SIGNS & BANNERS
  {
    slug: "outdoor-banner",
    name: "Outdoor Banner",
    category: "signs-banners",
    tagline: "Built to withstand sun, wind and rain.",
    description: "13 oz heavy-duty scrim vinyl with welded hems and grommets every 24\". Full-color outdoor-grade inks resist fading for 2+ years. Any custom size up to 10' × 50'.",
    fromPrice: 39.99,
    image: "https://images.unsplash.com/photo-1523800378286-dae1f0dae656?w=900",
    gallery: ["https://images.unsplash.com/photo-1523800378286-dae1f0dae656?w=900"],
    rating: 4.8,
    reviews: 198,
    features: ["13oz scrim vinyl", "Welded hems & grommets", "Fade-resistant outdoor inks", "Custom sizes"],
    sizes: ["2' × 4'", "3' × 6'", "4' × 8'", "5' × 10'", "Custom"],
    pricing: [
      { qty: 1, perUnit: 39.99, price: 39.99 },
      { qty: 2, perUnit: 35, price: 70 },
      { qty: 5, perUnit: 32, price: 160 },
    ],
    designFee: 55,
    productionDays: "4–6",
  },
  {
    slug: "indoor-banner",
    name: "Indoor Banner",
    category: "signs-banners",
    tagline: "Crisp color for storefronts and stages.",
    description: "Smooth 10 mil indoor vinyl banners with razor-sharp print, perfect for backdrops, photo walls and storefront promos. Pole-pocket, grommet or hemmed options on order.",
    fromPrice: 16.5,
    image: "https://images.unsplash.com/photo-1503694978374-8a2fa686963a?w=900",
    gallery: ["https://images.unsplash.com/photo-1503694978374-8a2fa686963a?w=900"],
    rating: 4.7,
    reviews: 121,
    features: ["10 mil indoor vinyl", "High-resolution print", "Custom sizes", "Hem, grommet, pocket options"],
    sizes: ["2' × 3'", "2' × 4'", "3' × 5'", "4' × 8'", "Custom"],
    pricing: [
      { qty: 1, perUnit: 16.5, price: 16.5 },
      { qty: 2, perUnit: 15, price: 30 },
      { qty: 5, perUnit: 14, price: 70 },
    ],
    designFee: 45,
    productionDays: "4–6",
  },

  // LABELS & STICKERS
  {
    slug: "waterproof-vinyl-labels",
    name: "Waterproof Vinyl Labels",
    category: "labels-stickers",
    tagline: "Print that survives the dishwasher.",
    description: "Heavy waterproof white vinyl labels with permanent adhesive — engineered for bottles, cosmetics, cans and outdoor products. UV-laminated for years of color life.",
    fromPrice: 39.99,
    image: "https://images.unsplash.com/photo-1633533452206-8ab246b00e30?w=900",
    gallery: ["https://images.unsplash.com/photo-1633533452206-8ab246b00e30?w=900"],
    rating: 4.9,
    reviews: 256,
    features: ["Waterproof white vinyl", "UV laminate top coat", "Permanent adhesive", "Any custom shape"],
    sizes: ["1\" × 2\"", "2\" × 3\"", "3\" × 4\"", "4\" × 6\"", "Custom"],
    shapes: ["Rectangle", "Circle", "Oval", "Square", "Die-cut"],
    pricing: [
      { qty: 100, perUnit: 0.40, price: 39.99 },
      { qty: 250, perUnit: 0.28, price: 69.99 },
      { qty: 500, perUnit: 0.20, price: 99.99 },
      { qty: 1000, perUnit: 0.14, price: 139.99 },
      { qty: 2500, perUnit: 0.10, price: 249.99 },
    ],
    designFee: 45,
    productionDays: "6–8",
  },
  {
    slug: "standard-labels",
    name: "Standard Labels",
    category: "labels-stickers",
    tagline: "Everyday labels with a premium finish.",
    description: "Smooth white paper labels with full-color print and your choice of matte or gloss laminate. Perfect for product packaging, shipping, mailing and tag-and-go retail.",
    fromPrice: 29.99,
    image: "https://images.unsplash.com/photo-1718670013921-2f144aba173a?w=900",
    gallery: ["https://images.unsplash.com/photo-1718670013921-2f144aba173a?w=900"],
    rating: 4.6,
    reviews: 167,
    features: ["Premium white paper", "Matte or gloss laminate", "Permanent or removable adhesive", "Custom sizes"],
    sizes: ["1\" × 2\"", "2\" × 3\"", "3\" × 4\"", "4\" × 6\"", "Custom"],
    finishes: ["Matte", "Gloss"],
    pricing: [
      { qty: 100, perUnit: 0.30, price: 29.99 },
      { qty: 250, perUnit: 0.20, price: 49.99 },
      { qty: 500, perUnit: 0.14, price: 69.99 },
      { qty: 1000, perUnit: 0.10, price: 99.99 },
      { qty: 2500, perUnit: 0.07, price: 174.99 },
    ],
    designFee: 35,
    productionDays: "5–6",
  },

  // PRINT STATIONERY
  {
    slug: "carbonless-forms",
    name: "Carbonless Forms",
    category: "print-stationery",
    tagline: "Carbon-free copies for invoices and receipts.",
    description: "2-part, 3-part or 4-part carbonless forms padded or booked. Custom-numbered sequences available. Perfect for invoices, work orders, receipts, and inspection reports.",
    fromPrice: 119.99,
    image: "https://images.pexels.com/photos/6620972/pexels-photo-6620972.jpeg?auto=compress&w=900",
    gallery: ["https://images.pexels.com/photos/6620972/pexels-photo-6620972.jpeg?auto=compress&w=900"],
    rating: 4.7,
    reviews: 89,
    features: ["2-part, 3-part or 4-part", "Numbered sequencing optional", "Padded or booked", "Custom sizes"],
    sizes: ["5.5\" × 8.5\"", "8.5\" × 11\""],
    parts: ["2-part", "3-part", "4-part"],
    pricing: [
      { qty: 250, perUnit: 0.48, price: 119.99 },
      { qty: 500, perUnit: 0.30, price: 149.99 },
      { qty: 1000, perUnit: 0.20, price: 199.99 },
      { qty: 2500, perUnit: 0.12, price: 299.99 },
    ],
    designFee: 55,
    productionDays: "7–9",
  },

  // GANG SHEET PRINTING
  {
    slug: "dtf-gang-sheet",
    name: "DTF Gang Sheet",
    category: "gang-sheet-printing",
    tagline: "Pack your designs onto one sheet — pay less per print.",
    description: "Direct-to-Film gang sheets let you arrange dozens of designs on a single 22\" wide roll. Heat-press transfers to cotton, poly, blends and more — vibrant white-ink under-base included.",
    fromPrice: 9.99,
    image: "https://images.unsplash.com/photo-1580566176138-daa588058b59?w=900",
    gallery: ["https://images.unsplash.com/photo-1580566176138-daa588058b59?w=900"],
    rating: 4.9,
    reviews: 412,
    features: ["22\" wide DTF roll", "White under-base included", "Works on most fabrics", "Pay per linear foot"],
    sizes: ["22\" × 12\"", "22\" × 24\"", "22\" × 36\"", "22\" × 48\"", "22\" × 60\"", "22\" × 120\""],
    pricing: [
      { qty: 1, perUnit: 9.99, price: 9.99 },
      { qty: 2, perUnit: 17.99, price: 17.99 },
      { qty: 3, perUnit: 25.99, price: 25.99 },
      { qty: 5, perUnit: 39.99, price: 39.99 },
      { qty: 10, perUnit: 69.99, price: 69.99 },
    ],
    designFee: 0,
    productionDays: "2–4",
  },
];

export const HERO_SLIDES = [
  {
    type: "rebrand",
    badge: "Big news for Broward",
    oldName: "Design Plus",
    newName: "Let's Print",
    subtitle: "Same Commitment · Same team · Bigger Vision. A bolder name — and an even sharper print experience.",
    cta: "Check out Let's Print Website",
    href: "https://www.letsprint.ai",
    accent: "from-rose-500 via-orange-500 to-amber-400",
    duration: 12000,
  },
  {
    badge: "Save $8.00",
    title: "For all Printing Solutions",
    subtitle: "From business cards to banners — premium print, made fresh in Fort Lauderdale, ready in days.",
    cta: "Shop Business Cards",
    href: "/category/business-cards",
    accent: "from-orange-400 via-rose-400 to-pink-500",
  },
  {
    badge: "30% Off",
    title: "Make Awesome Products",
    subtitle: "Heavy 16pt cardstock, soft-touch finishes, raised foil and Spot UV — we sweat the small stuff.",
    cta: "Shop Marketing Material",
    href: "/category/marketing-material",
    accent: "from-teal-400 via-cyan-500 to-blue-500",
  },
  {
    badge: "Free Local Pickup",
    title: "For all Printing Services",
    subtitle: "Pick up in-store at our Fort Lauderdale studio — or get free local delivery on orders over $65.",
    cta: "Shop Signs & Banners",
    href: "/category/signs-banners",
    accent: "from-fuchsia-400 via-violet-500 to-indigo-500",
  },
];

export const PROMO_BANNERS = [
  {
    label: "Best Seller",
    title: "Spot UV Business Cards",
    img: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/myjtrcay_SPOT%20UV%202.PNG",
    href: "/product/spot-uv-business-cards",
    bg: "bg-amber-50",
  },
  {
    label: "Save 20%",
    title: "Retractable Banners",
    img: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/30wrpnn7_image.png",
    href: "/product/retractable-banner",
    bg: "bg-rose-50",
  },
  {
    label: "Save 30%",
    title: "Waterproof Vinyl Labels",
    img: "https://images.unsplash.com/photo-1633533452206-8ab246b00e30?w=600",
    href: "/product/waterproof-vinyl-labels",
    bg: "bg-emerald-50",
  },
];

export const TESTIMONIALS = [
  {
    name: "Maria S.",
    role: "Boutique Owner — Wilton Manors",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200",
    quote: "Print quality is unreal. The square business cards arrived perfect — heavy stock, vibrant colors. I'll never order anywhere else.",
  },
  {
    name: "Daniel R.",
    role: "Campaign Director",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200",
    quote: "Ordered yard signs for the campaign. Fast turnaround, great communication, and the H-stakes were included — pure value.",
  },
  {
    name: "Selene W.",
    role: "Designer at Lift",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200",
    quote: "From the design help to the final delivery — Design Plus made it ridiculously easy. Custom stickers came out gorgeous.",
  },
  {
    name: "James L.",
    role: "Event Planner",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200",
    quote: "Their retractable banner is the best I've owned in 12 years of events. The deluxe chrome base rolls like butter.",
  },
];

export const BLOG_POSTS = [
  {
    slug: "why-car-magnets-matter",
    title: "Your Business on the Move: Why Car Magnets Matter",
    category: "Marketing",
    date: "Mar 12, 2026",
    image: "https://images.unsplash.com/photo-1593238404535-cda7ae2fe50b?w=900",
    excerpt: "Car magnets aren't just decoration — they're one of the most underrated print marketing tools for local businesses. Here's why they pay off in Broward County.",
  },
  {
    slug: "15-sticker-designs",
    title: "15 Sticker Designs to Boost Your Broward Brand",
    category: "Design",
    date: "Feb 22, 2026",
    image: "https://images.unsplash.com/photo-1633533452206-8ab246b00e30?w=900",
    excerpt: "Stickers aren't just fun — they're powerful little marketing tools that turn any surface into a mini billboard. Here are 15 ideas with serious Broward flavor.",
  },
  {
    slug: "3-branding-tips",
    title: "3 Simple Branding Tips for Small Businesses",
    category: "Print Shop",
    date: "Jan 30, 2026",
    image: "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?w=900",
    excerpt: "Stand out, stay remembered, and grow stronger — your brand deserves it. Three practical branding moves you can make this week.",
  },
];

export const TRUSTED_BRANDS = [
  "The UPS Store", "Broward Health", "Smoothie King", "Snappers Fish & Chicken", "Crafty Crab", "Publix Local",
];
